import '../../style/index.less';
import './index.less';

// style dependencies
import '../../tooltip/style';
import "../../style/nsky/reset/slider/index.less";



/** WEBPACK FOOTER **
 ** ./components/slider/style/index.js
 **/